"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticStorageV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SyntheticStorageV1Factory = /** @class */ (function (_super) {
    __extends(SyntheticStorageV1Factory, _super);
    function SyntheticStorageV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SyntheticStorageV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SyntheticStorageV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SyntheticStorageV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SyntheticStorageV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SyntheticStorageV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SyntheticStorageV1Factory;
}(contracts_1.ContractFactory));
exports.SyntheticStorageV1Factory = SyntheticStorageV1Factory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "permitNonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610183806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c8063191d0ffc1461004657806330adf81f1461006f5780633644e51514610077575b600080fd5b6100596100543660046100cc565b61007f565b6040516100669190610101565b60405180910390f35b610059610091565b6100596100b5565b60076020526000908152604090205481565b7f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c981565b60065481565b80356100c681610129565b92915050565b6000602082840312156100de57600080fd5b60006100ea84846100bb565b949350505050565b6100fb8161011a565b82525050565b602081016100c682846100f2565b60006100c68261011d565b90565b6001600160a01b031690565b6101328161010f565b811461013d57600080fd5b5056fea365627a7a72315820632ada9d7bf4d9ca5728bf244332433029725832b9db1bd17a71883a064460536c6578706572696d656e74616cf564736f6c63430005100040";
//# sourceMappingURL=SyntheticStorageV1Factory.js.map